import api from '../index';

export default {
  get(q = '', month = null, status = '') {
    let url = '/blog/results';
    const filters = [];

    q.trim() !== '' && filters.push(`q=${q}`);
    month && filters.push(`month=${month}`);
    status.trim() !== '' && filters.push(`status=${status}`);

    url = `${url}?${filters.join('&')}`;

    return api.get(url);
  },
  getById(id) {
    return api.get(`/blog/results/${id}`);
  },
  create(payload) {
    return api.post(`/blog/results`, { blog_results: payload });
  },
  update(payload) {
    return api.put(`/blog/results`, { blog_results: [payload] });
  },
  updateMultiple(payload) {
    return api.put(`/blog/results`, { blog_results: payload });
  },
  updatePriority(payload) {
    return api.put(`/blog/results/priority`, { blog_results: [payload] });
  },
};
